export { default as Img200 } from './processed/200/VANITY-FAIR_S01.jpg';
export { default as Img400 } from './processed/400/VANITY-FAIR_S01.jpg';
export { default as Imgthumb } from './processed/thumb/VANITY-FAIR_S01.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/VANITY-FAIR_S01.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/VANITY-FAIR_S01.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      191,
      47,
      50
    ],
    "_population": 175,
    "_hsl": [
      0.9965277777777778,
      0.6050420168067226,
      0.4666666666666667
    ]
  },
  "LightVibrant": {
    "_rgb": [
      218,
      77,
      88
    ],
    "_population": 46,
    "_hsl": [
      0.9869976359338062,
      0.6558139534883722,
      0.5784313725490196
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      152,
      34,
      33
    ],
    "_population": 1718,
    "_hsl": [
      0.0014005602240896309,
      0.6432432432432432,
      0.3627450980392157
    ]
  },
  "Muted": {
    "_rgb": [
      156,
      110,
      84
    ],
    "_population": 96,
    "_hsl": [
      0.060185185185185196,
      0.30000000000000004,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      184,
      169
    ],
    "_population": 196,
    "_hsl": [
      0.06944444444444443,
      0.2647058823529413,
      0.7333333333333334
    ]
  },
  "DarkMuted": {
    "_rgb": [
      124,
      76,
      58
    ],
    "_population": 140,
    "_hsl": [
      0.04545454545454546,
      0.36263736263736257,
      0.3568627450980392
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/VANITY-FAIR_S01.js